<template>
	<div :id="'module-text-' + dModule.id">
		<v-container class="text-center timer-display">
			<v-row justify="center" v-if="!timeExpired">
				<v-col v-if="displayDays" cols="2" class="pa-0">
					<span class="time">{{ days }}</span>
				</v-col>
				<v-col
					v-if="displayDays"
					cols="1"
					class="pa-0"
					align-self="center"
				>
					:
				</v-col>
				<v-col cols="2" class="pa-0">
					<span class="time">{{ hours }}</span>
				</v-col>
				<v-col cols="1" class="pa-0" align-self="center"> : </v-col>
				<v-col cols="2" class="pa-0">
					<span class="time">{{ minutes }}</span>
				</v-col>
				<v-col cols="1" class="pa-0" align-self="center"> : </v-col>
				<v-col cols="2" class="pa-0">
					<span class="time">{{ seconds }}</span>
				</v-col>
			</v-row>
			<v-row justify="center" v-if="!timeExpired">
				<v-col v-if="displayDays" cols="2" class="pa-0">
					<span class="sub-text days">{{ $t("timer.days") }}</span>
				</v-col>
				<v-col v-if="displayDays" cols="1" class="pa-0" />
				<v-col cols="2" class="pa-0">
					<span class="sub-text hours">{{ $t("timer.hours") }}</span>
				</v-col>
				<v-col cols="1" class="pa-0" />
				<v-col cols="2" class="pa-0">
					<span class="sub-text minutes">
						{{ $t("timer.minutes") }}
					</span>
				</v-col>
				<v-col cols="1" class="pa-0" />
				<v-col cols="2" class="pa-0">
					<span class="sub-text seconds">
						{{ $t("timer.seconds") }}
					</span>
				</v-col>
			</v-row>
			<v-row v-else>
				<v-col cols="12">
					<span class="expired-time">
						{{ dModule.data.text }}
					</span>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
export default {
	name: "TimerModule",
	props: {
		data: Object,
	},
	data() {
		return {
			dModule: this.data,
			interval: null,
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0,
			displayDays: false,
			timeExpired: false,
		};
	},
	mounted() {
		this.interval = setInterval(() => {
			this.countdown();
		}, 1000);
		this.displayDate();
		this.displayTimer();
	},
	methods: {
		countdown() {
			if (this.timeExpired) return;
			// Get current time
			let now = new Date().getTime();
			// Convert set time
			let time = new Date(this.dModule.data.countdownDate) - now;

			if (time < 0) {
				this.timeExpired = true;
				clearInterval(this.interval);
				return;
			}

			this.days = Math.floor(time / (1000 * 60 * 60 * 24))
				.toString()
				.padStart(2, "0");
			this.hours = Math.floor(
				(time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
			)
				.toString()
				.padStart(2, "0");
			this.minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60))
				.toString()
				.padStart(2, "0");
			this.seconds = Math.floor((time % (1000 * 60)) / 1000)
				.toString()
				.padStart(2, "0");
		},
		displayDate() {
			let now = new Date().getTime();
			let time = new Date(this.dModule.data.countdownDate) - now;
			this.displayDays = Math.floor(time / (1000 * 60 * 60 * 24)) > 0;
		},
		displayTimer() {
			let now = new Date().getTime();
			let time = new Date(this.dModule.data.countdownDate) - now;
			if (time < 0) this.timeExpired = true;
		},
	},
};
</script>

<style scoped>
.timer-display {
	border-radius: 8px;
	background: white;
}
.sub-text {
	font-weight: bold;
	font-size: small;
	color: rgba(from var(--v-on-surface-base) r g b / 0.3);
}
.time {
	font-weight: bold;
	font-size: x-large;
}
.expired-time {
	font-size: xx-large;
}
.row {
	margin: unset;
}
</style>